import { applyMiddleware, createStore } from "redux";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import persistStore from "redux-persist/es/persistStore";
import { rootReducer } from "./root-reducer";
import rootSaga from "./rootSaga";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["application", "video", "home", "explore", "browse", "collections", "tags", "niches", "user"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
const middlewareEnhancer = applyMiddleware(...middlewares);
const composeEnhancers = composeWithDevTools({
  name: "RedGifs",
});

const store = createStore(
  persistedReducer,
  composeEnhancers(middlewareEnhancer)
);
sagaMiddleware.run(rootSaga);
const persistor = persistStore(store);

export { store, persistor };
